import { InjectionToken } from '@angular/core';

export const SSRServerUrlToken = new InjectionToken<string>('SSRServerUrl');
export const SSRActiveDomainToken = new InjectionToken<string>(
	'SSRActiveDomain',
);
